export enum TemplateId {
    HEADER = 'header',
    CONTENT = 'content',
}
